/**
 * ProfilePicture component
 * Extracted from ProfileMenu to provide a reusable avatar renderer.
 * Supports Auth0 User objects that may contain either `picture` or a custom `profileImage` field.
 */
import React from 'react'

import { User } from '@auth0/auth0-react'

export interface ProfilePictureProps {
  user?: (User & { profileImage?: string; picture?: string }) | undefined
  /** Optional alt text (kept default typo to preserve existing tests) */
  alt?: string
  /** Additional class names for the <img> element */
  className?: string
  /** Whether the image should be focusable */
  tabIndex?: number
}

export const ProfilePicture: React.FC<ProfilePictureProps> = ({
  user,
  alt = 'Profile picure',
  className = 'rounded-full w-7 h-7 lg:w-9 lg:h-9',
  tabIndex = 0,
}) => {
  if (!user) return null
  const imgSrc = user.picture || user.profileImage || undefined
  return <img tabIndex={tabIndex} alt={alt} src={imgSrc} className={className} />
}

export default ProfilePicture
